import SEO from "@/common/components/seo";
import FadeIn from "@/common/components/fade-in";
import GiveawaysHeader from "../components/giveaways-header";
import CurrentPromotions from "../containers/current-promotions";
import PreviousPrizes from "../containers/previous-prizes";
import UpComingPrizes from "../containers/upcoming-prizes";

export default function GiveawaysPage() {
	return (
		<div>
			<SEO
				title="Giveaways - Reel Rewards"
				description="Explore live giveaways, what’s coming next, and the prizes we’ve already sent home with our lucky legends."
			/>
			<GiveawaysHeader />
			<FadeIn>
				<CurrentPromotions />
			</FadeIn>
			<FadeIn>
				<UpComingPrizes />
			</FadeIn>
			<FadeIn>
				<PreviousPrizes />
			</FadeIn>
		</div>
	);
}
